import { atom } from "jotai";
import { ECompanyContentTab } from "library/types";

export const employerContentTabAtom = atom<ECompanyContentTab>(ECompanyContentTab.documents);
